import { FC } from 'react';
import { PAYWALL_BACKDROP_Z_INDEX, PAYWALL_Z_INDEX } from 'Constants/StackingLevels';
import { useNavigate } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import './paywall.css';
import WelcomeButton from '../TrialWelcome/WelcomeButton';
import { useAccountDialogShown } from 'Utils/accountDialogShown';
import { useHardwareBackClosesLayer } from 'Hooks/useHardwareBack';

// MUS-607: on a phone in landscape the card is about 330px high, and the
// 100px space above the title and below the text pushed LET'S FLOW out of the
// card and off the screen. On a screen this short the spacing is tighter.
export const SHORT_SCREEN_QUERY = '(max-height: 520px)';

interface ConfirmationProps {
  setShowConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
}

const Confirmation: FC<ConfirmationProps> = ({ setShowConfirmation }) => {
  const navigate = useNavigate();
  const shortScreen = useMediaQuery(SHORT_SCREEN_QUERY);
  // MUS-651: up, it holds back an announcement that does not block the app.
  // Reported here, so every place that shows it (the payment flow, and the
  // roadmap after a web checkout returns) counts.
  useAccountDialogShown(true);
  const handleRedirect = () => {
    setShowConfirmation(false);
    navigate('/roadmap', { replace: true });
  };
  // Android's Back does what the card's only button does.
  useHardwareBackClosesLayer(true, handleRedirect, PAYWALL_Z_INDEX);

  return (
    <>
      <Box className="modal-outer" sx={{ zIndex: PAYWALL_BACKDROP_Z_INDEX }} />
      <Box className="modal-inner2" sx={{ zIndex: PAYWALL_Z_INDEX }}>
        <Box
          className={
            shortScreen
              ? 'confirmation-container confirmation-container--short'
              : 'confirmation-container'
          }
        >
          <h2 className="confirmation-title">Thank you for your payment!</h2>
          <p className="confirmation-desc">We hope you continue enjoying MuseFlow.</p>
          <WelcomeButton onClick={handleRedirect} style={{ width: '200px' }}>
            LET&apos;S FLOW
          </WelcomeButton>
        </Box>
      </Box>
    </>
  );
};

export default Confirmation;
